<div class="container-fluid test">
  <div class="row d-flex flex-sm-row  flex-column-reverse ">
    <div class="col-md-6 bgS1 p-5 position-relative d-sm-block d-none aos-init aos-animate" data-aos="fade-up">
      <div class="row">
        <div class="col-md-8 colmd8W m-auto">
          <div class="row mb-5 d-none d-sm-block">
            <div class="col">
              <a data-testid="auto-app-resetpassword-a-1" class="navbar-brand z2" href="https://webbtree.com/"><img src="assets/webtree.png" class="img-fluid"
                  alt="Webbtree" title="Webbtree"></a>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col">
              <h1 class="f-32 font-weight-bold mb-3">
                Source.Enrich.Nurture
              </h1>

            </div>
          </div>
          <div class="row mb-4">
            <div class="col text-center">
              <img src="assets/group-7@2x.png" class="img-fluid" alt="Search toolbox"
                title="Search toolbox">

            </div>
          </div>
          <div class="position-absolute tr0 ">
            <img src="assets/g2c3.png" alt="">
          </div>
          <div class="row">
            <div class="col text-center">
              <p>Stay tuned for updates</p>
              <p> <span class="social-icon">
                  <a data-testid="auto-app-resetpassword-a-2" class="" href="https://www.linkedin.com/company/webbtree/" target="_blank"><i
                      class="fab fa-linkedin f-26 linkedinColor mr-4"></i></a>
                  <a data-testid="auto-app-resetpassword-a-3" class="" href="mailto:support@webbtree.com" target="_blank"><i
                      class="fas fa-envelope f-26 emailColor mr-4"></i></a>
                  <a data-testid="auto-app-resetpassword-a-4" class="" href="https://www.facebook.com/webbtreeapp/" target="_blank"> <i
                      class="fab fa-facebook-square f-26 facebookColor mr-4"></i></a>

                  <a data-testid="auto-app-resetpassword-a-5" class="" href="https://twitter.com/Webbtreeapp/" target="_blank"><i
                      class="fa-brands fa-square-x-twitter f-26 twitterColor"></i></a>
                </span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 p-5 testmobile aos-init aos-animate bg-white-h100" data-aos="fade-up">

      <div class="row">
        <div class="col-md-12">

          <div class="row mb-3">
            <div class="col text-right">
              <span>
                Already have an account? &nbsp; &nbsp; <button data-testid="auto-app-resetpassword-button-1" class="wc-btn btnreset col-md-2 m-auto py-1"
                  routerLink="/signup">Sign In</button>
              </span>
              <p> <img class="mt-4" src="assets/g2c4.png" alt=""></p>
            </div>
          </div>


          <div *ngIf="forgetpassword" class="col-10">
            <div class="row mb-3">
              <div class="col pr-0">
                <h1 class="f-32 font-weight-bold mb-3">
                  Forgot your password
                </h1>
                <p>
                  Don't worry. We'll email you a password reset link with instructions.
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col pr-sm-0">
              <form [formGroup]="forgetpassword_form">
                  <div class="mr-4 mb-3">
                    <div class="f-14 font-weight-500 mb-3"> Email Id
                      <input data-testid="auto-app-resetpassword-input-1" type="text" placeholder="Enter Email Id" class="wc-form-control nobg mt-1" formControlName = 'emailid'>
                    </div>

                    <p class="f-12 font-weight-500" *ngIf="forgetpassword_form.get('emailid').errors?.required && (forgetpassword_form['controls'].emailid.dirty || forgetpassword_form['controls'].emailid.touched)"
                        [ngClass]="['text-left','text-danger' ,'f-12']">Email ID is required</p>
                      <p class="text-danger f-12 font-weight-500" *ngIf="forgetpassword_form['controls'].emailid.hasError('pattern')">
                        Must be a valid EmailId</p>

                  <div class="mt-3">
                    <button data-testid="auto-app-resetpassword-button-2" type="button" class="btn-trms-medium mr-4"
                      data-dismiss="modal" (click)="requestlink()">Request Reset Link</button>
                  </div>
              </div>
              </form>
              <div class="text-right pr-3 w-65 d-none d-sm-block">
                <img src="" class="img-fluid" alt="">
              </div>
            </div>
          </div>
          </div>

        <div *ngIf="resetpassword">
          <div class="row mb-3">
            <div class="col pr-0">
              <h1 class="f-32 font-weight-bold mb-3">
                Reset your password
              </h1>
            </div>
          </div>
          <div class="row">
            <div class="col pr-sm-0">
              <form [formGroup]="resetpassword_form">

                <div class="mr-4 mb-3">
                  <div class="f-12 font-weight-500 mb-3"> Set Password
                    <input data-testid="auto-app-resetpassword-input-2" type="password" placeholder="Enter Password" class="wc-form-control nobg mt-1"formControlName="password">

                    <p *ngIf="resetpassword_form.get('password').errors?.required && (resetpassword_form['controls'].password.dirty || resetpassword_form['controls'].password.touched)"
                      [ngClass]="['text-left','my-1','text-danger']">Password is required</p>
                    <p *ngIf="!resetpassword_form.get('password').errors?.required && resetpassword_form.get('password').invalid && (resetpassword_form['controls'].password.dirty || resetpassword_form['controls'].password.touched)"
                      [ngClass]="['text-left','my-1','text-danger']">Password must be 8+ characters and include a number, an uppercase letter, a lowercase letter and a special character, and must not contain "password"</p>
                  </div>


                  <div class="f-12 font-weight-500 mb-3"> Re-type Password
                    <input data-testid="auto-app-resetpassword-input-3" type="password" placeholder="Re-type Password" (input)="reconfirmpwd()"class="wc-form-control nobg mt-1" formControlName="confirmpwd"
                    (keyup.enter)="resetpwd()" >

                    <p *ngIf="resetpassword_form.get('confirmpwd').errors?.required && (resetpassword_form['controls'].confirmpwd.dirty || resetpassword_form['controls'].confirmpwd.touched)"
                    [ngClass]="['text-left','my-1','text-danger']">Confirm password is required</p>

                    <p class="text-danger f-12 pt-1"*ngIf="resetpassword_form['controls'].confirmpwd.hasError('invalidpwd')">
                      Password Doesn't Match </p>

                  </div>

                <div class="mt-5">
                  <button data-testid="auto-app-resetpassword-button-3" type="button" class="btn-trms-medium mr-4"
                    data-dismiss="modal" (click)="resetpwd()">Reset my password</button>
                </div>
            </div>
            </form>
            <div class="text-right pr-3 w-65 d-none d-sm-block">
              <img src="" class="img-fluid" alt="">
            </div>
          </div>
        </div>
        </div>


        <div class="row text-center" *ngIf="resetpwsuccess">
          <div class="col-md-12">
            <div class="row">
              <div class="col pr-sm-0">
                <img src="assets/undraw-security-on-ff-2-u.png" class="img-fluid" alt="">

                <p class="font-weight-500 f-14 mt-4">
                  You can now use new password to sign in to
                  your account
                </p>

              </div>
            </div>
            <button data-testid="auto-app-resetpassword-button-4" type="button" class="btn wc-btn-lg f-14 font-weight-bold bgRequestBtn w-60 text-center"
              data-dismiss="modal" routerLink="/login">Sign In</button>
          </div>
        </div>


    </div>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success"  (close)="successMessage = ''" >
  <span class="successCheck"><i class="fal fa-check"></i> </span>
 <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage"   type="danger"  (close)="errorMessage = ''">
 <span class="errorCheck"><i class="fal fa-times"></i></span>
 <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
